
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.538 10.367v.665h1.407c.58 0 1.055.448 1.055.996v7.975c0 .548-.475.997-1.055.997h-7.737c-.58 0-1.055-.449-1.055-.997v-7.975c0-.548.475-.996 1.055-.996h1.407v-.665h4.923zM18.153 7.158c.188 0 .341.145.341.323v1.753a.333.333 0 01-.341.323h-6.141a.333.333 0 01-.342-.323V7.481c0-.178.153-.323.342-.323h6.14zM5.966 3.323c0-.178.153-.323.341-.323h8.162c.189 0 .342.145.342.323v2.463a.333.333 0 01-.342.323H6.307a.333.333 0 01-.341-.323V3.323zM9.823 9.904H9.62c-.32.02-.961.23-.961.908V20.94h-3.29C4.614 20.94 4 20.358 4 19.647V9.312c0-.71.615-1.292 1.367-1.292H7.19v-.862h2.633v2.746z","fill":"#008C89"}})])
          )
        }
      }
    